<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><circle cx="256" cy="256" r="256" fill="#fefefe"/><path fill="#d4213d" d="M512 256a256 256 0 0 1-512 0"/></svg>
</template>

<script>
    export default {
        name: "pl"
    }
</script>

<style scoped>

</style>
